import React from 'react'
import _get from 'lodash/get'
import _set from 'lodash/set'
import { List, Map } from 'immutable'
import {
  CONTENT_IMAGE_TYPE_POSTER_3X4,
} from '../../services/content/index'
import Picture, { IMAGE_TYPE_WEBP, IMAGE_LOADING_LAZY } from '../Picture/index'
import { get as getConfig } from '../../config/index'
import {
  parse as parseQuery,
  stringify as stringifyQuery,
} from '../../services/query-string/index'

const config = getConfig()
const optimizedImagesEnabled = !!_get(config, ['features', 'optimizedImages'])

/**
 * The share page tile component
 * @param {Object} props - The props
 * @param {Map} props.data - The tile item data
 * @returns {JSX.Element} The tile component
 */
function SharePageTile (props) {
  const { data } = props

  const title = data.get('title', '')
  const images = data.get('images', List()) || List()
  const imageData = images.find((img) => img.get('type') === CONTENT_IMAGE_TYPE_POSTER_3X4) || Map()
  const image = imageData.get('url', '')
  const imageWidth = '385'
  const imageHeight = '513'
  let imageUrl = ''
  let fallbackImageUrl = ''

  try {
    if (optimizedImagesEnabled) {
      const fallbackImageUrlObject = new URL(image)
      const imageUrlObject = new URL(image)
      const parsedFallbackImageQuery = parseQuery(_get(fallbackImageUrlObject, 'search', '')) || {}
      const parsedImageQuery = parseQuery(_get(imageUrlObject, 'search', '')) || {}
      const fallbackImageOptions = {
        ...parsedFallbackImageQuery,
        w: imageWidth,
        h: imageHeight,
        fm: 'jpg',
        compress: 'auto',
      }
      const imageOptions = {
        ...parsedImageQuery,
        w: imageWidth,
        h: imageHeight,
        fm: 'webp',
        q: '100',
      }

      const stringifiedFallbackQuery = stringifyQuery(fallbackImageOptions)
      const stringifiedImageQuery = stringifyQuery(imageOptions)

      // set the search string back onto the fallback URL
      _set(fallbackImageUrlObject, 'search', stringifiedFallbackQuery)

      // set the search string back onto the image URL
      _set(imageUrlObject, 'search', stringifiedImageQuery)

      fallbackImageUrl = fallbackImageUrlObject.toString()
      imageUrl = imageUrlObject.toString()
    }
  } catch (e) {
    fallbackImageUrl = image
    imageUrl = image
  }

  return (
    <div className="share-page__tile">
      <div className="share-page__tile-hero">
        {
          optimizedImagesEnabled
            ? <Picture
              fallbackSrc={fallbackImageUrl}
              width={imageWidth}
              height={imageHeight}
              alt={title}
              loading={IMAGE_LOADING_LAZY}
              sources={[
                {
                  type: IMAGE_TYPE_WEBP,
                  srcSet: imageUrl,
                },
              ]}
            />
            : <img
              src={image}
              loading="lazy"
              alt={title}
            />
        }
      </div>
    </div>
  )
}

export default SharePageTile
